(function () {
  if (window.__designGroupSwatchesGlobalInit) return;
  window.__designGroupSwatchesGlobalInit = true;

  var GAP = 8;

  function getPortal() {
    var id = 'design-group-dropdown-portal';
    var portal = document.getElementById(id);
    if (!portal) {
      portal = document.createElement('div');
      portal.id = id;
      portal.style.cssText = 'position:fixed;inset:0;z-index:9998;pointer-events:none;';
      document.body.appendChild(portal);
    }
    return portal;
  }

  function positionInPortal(trigger, dropdown) {
    var rect = trigger.getBoundingClientRect();
    dropdown.style.top = rect.bottom + GAP + 'px';
    dropdown.style.left = rect.left + 'px';
  }

  function closeDropdown(container, trigger, dropdown) {
    if (!container || !dropdown) return;
    var home = dropdown._designGroupHome;
    if (home && dropdown.getAttribute('data-portaled') === 'true') {
      dropdown.removeAttribute('data-portaled');
      dropdown.style.position = '';
      dropdown.style.top = '';
      dropdown.style.left = '';
      home.appendChild(dropdown);
    }
    container.setAttribute('data-open', 'false');
    if (trigger) trigger.setAttribute('aria-expanded', 'false');
    dropdown.setAttribute('aria-hidden', 'true');
  }

  function openDropdownInPortal(container, trigger, dropdown) {
    dropdown._designGroupHome = container;
    dropdown.setAttribute('data-portaled', 'true');
    dropdown.style.position = 'fixed';
    dropdown.style.zIndex = '2147483647';
    dropdown.style.pointerEvents = 'auto';
    getPortal().appendChild(dropdown);
    positionInPortal(trigger, dropdown);
  }

  function repositionPortaledDropdowns() {
    var portal = document.getElementById('design-group-dropdown-portal');
    if (!portal) return;
    portal
      .querySelectorAll('.grid-product__design-group-swatches__dropdown[data-portaled="true"]')
      .forEach(function (dropdown) {
        var container = dropdown._designGroupHome;
        if (!container) return;
        var trigger = container.querySelector('.grid-product__design-group-swatch-trigger');
        if (trigger) positionInPortal(trigger, dropdown);
      });
  }

  function initDesignGroupSwatches() {
    var containers = document.querySelectorAll(
      '[data-design-group-swatches]:not([data-initialized])'
    );
    containers.forEach(function (container) {
      container.setAttribute('data-initialized', 'true');
      var trigger = container.querySelector('.grid-product__design-group-swatch-trigger');
      var dropdown = container.querySelector('.grid-product__design-group-swatches__dropdown');
      if (!trigger || !dropdown) return;
      container._designGroupDropdown = dropdown;
      container._designGroupTrigger = trigger;
      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var isOpen = container.getAttribute('data-open') === 'true';
        document.querySelectorAll('[data-design-group-swatches]').forEach(function (other) {
          if (other !== container) {
            closeDropdown(other, other._designGroupTrigger, other._designGroupDropdown);
          }
        });
        var newState = !isOpen;
        container.setAttribute('data-open', newState ? 'true' : 'false');
        trigger.setAttribute('aria-expanded', newState ? 'true' : 'false');
        dropdown.setAttribute('aria-hidden', newState ? 'false' : 'true');
        if (newState) openDropdownInPortal(container, trigger, dropdown);
        else closeDropdown(container, trigger, dropdown);
      });
    });
  }

  function runStorefrontApiDesignGroupCount() {
    var config = window.__storefrontApiConfig;
    if (!config || !config.token || !config.url) return;
    var containers = document.querySelectorAll(
      '[data-design-group-swatches][data-api-count="true"]:not([data-api-loaded])'
    );
    if (!containers.length) return;
    var byId = {};
    containers.forEach(function (container) {
      var id = container.getAttribute('data-design-group-id');
      if (!id) return;
      if (!byId[id]) byId[id] = [];
      byId[id].push(container);
    });

    Object.keys(byId).forEach(function (id) {
      var allEdges = [];
      function fetchPage(cursor) {
        fetch(config.url, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Shopify-Storefront-Access-Token': config.token
          },
          body: JSON.stringify({
            query:
              'query DesignGroupCount($cursor: String) { products(first: 250, after: $cursor) { pageInfo { hasNextPage endCursor } edges { node { id handle title metafield(namespace: "custom", key: "design_group") { value } featuredImage { url(transform: { maxWidth: 80 }) } } } } }',
            variables: { cursor: cursor }
          })
        })
          .then(function (r) {
            return r.json();
          })
          .then(function (res) {
            var data = res.data && res.data.products;
            var edges = data && data.edges ? data.edges : [];
            var pageInfo = data && data.pageInfo ? data.pageInfo : {};
            allEdges = allEdges.concat(edges);
            if (pageInfo.hasNextPage && pageInfo.endCursor) return fetchPage(pageInfo.endCursor);

            var matching = allEdges.filter(function (edge) {
              var value = edge.node && edge.node.metafield && edge.node.metafield.value;
              return value === id;
            });
            var count = matching.length;
            var origin = location.origin || '';
            byId[id].forEach(function (el) {
              var countEl = el.querySelector('[data-design-group-count]');
              if (countEl) countEl.textContent = count + ' Colors';
              if (count <= 1) {
                el.style.display = 'none';
              } else {
                var dropdownContent = el.querySelector(
                  '.grid-product__design-group-swatches__dropdown-content[data-api-dropdown="true"]'
                );
                if (dropdownContent && matching.length) {
                  var currentId = el.getAttribute('data-current-product-id') || '';
                  dropdownContent.innerHTML = matching
                    .map(function (edge) {
                      var n = edge.node;
                      var nodeId = (n.id || '').split('/').pop() || '';
                      var isCurrent = currentId && nodeId === currentId;
                      var url = origin + '/products/' + (n.handle || '');
                      var title = (n.title || '').replace(/"/g, '&quot;');
                      var image =
                        n.featuredImage && n.featuredImage.url
                          ? '<img src="' +
                            n.featuredImage.url.replace(/"/g, '&quot;') +
                            '" alt="' +
                            title +
                            '" class="grid-product__design-group-swatch__image" loading="lazy" width="40" height="40">'
                          : '<div class="grid-product__design-group-swatch__image grid-product__design-group-swatch__image--placeholder">' +
                            (n.title || '').substring(0, 8) +
                            '</div>';
                      return (
                        '<a href="' +
                        url.replace(/"/g, '&quot;') +
                        '" class="grid-product__design-group-swatch' +
                        (isCurrent ? ' grid-product__design-group-swatch--current' : '') +
                        '" role="menuitem" aria-label="' +
                        title +
                        '"' +
                        (isCurrent ? ' aria-current="true"' : '') +
                        '>' +
                        image +
                        '</a>'
                      );
                    })
                    .join('');
                }
              }
              el.setAttribute('data-api-loaded', 'true');
            });
          })
          .catch(function () {
            byId[id].forEach(function (el) {
              var countEl = el.querySelector('[data-design-group-count]');
              if (countEl) countEl.textContent = '0 Colors';
              el.style.display = 'none';
              el.setAttribute('data-api-loaded', 'true');
            });
          });
      }
      fetchPage(null);
    });
  }

  window.initDesignGroupSwatches = initDesignGroupSwatches;
  window.runStorefrontApiDesignGroupCount = runStorefrontApiDesignGroupCount;

  if (!window.__designGroupSwatchesScrollResizeBound) {
    window.__designGroupSwatchesScrollResizeBound = true;
    window.addEventListener('scroll', repositionPortaledDropdowns, true);
    window.addEventListener('resize', repositionPortaledDropdowns);
  }

  document.addEventListener(
    'click',
    function (e) {
      var trigger = e.target.closest('.grid-product__design-group-swatch-trigger');
      if (trigger) return;
      if (
        !e.target.closest('[data-design-group-swatches]') &&
        !e.target.closest('.grid-product__design-group-swatches__dropdown')
      ) {
        document.querySelectorAll('[data-design-group-swatches][data-open="true"]').forEach(function (container) {
          closeDropdown(container, container._designGroupTrigger, container._designGroupDropdown);
        });
      }
    },
    true
  );

  if (!window.__designGroupSwatchesObserverBound) {
    window.__designGroupSwatchesObserverBound = true;
    var tick = null;
    var observer = new MutationObserver(function (mutations) {
      var shouldRun = false;
      for (var i = 0; i < mutations.length && !shouldRun; i++) {
        var mutation = mutations[i];
        if (!mutation.addedNodes || mutation.addedNodes.length === 0) continue;
        for (var j = 0; j < mutation.addedNodes.length; j++) {
          var node = mutation.addedNodes[j];
          if (!node || node.nodeType !== 1) continue;
          if (
            (node.matches && node.matches('[data-design-group-swatches], recently-viewed, product-recommendations')) ||
            (node.querySelector &&
              node.querySelector('[data-design-group-swatches], recently-viewed, product-recommendations'))
          ) {
            shouldRun = true;
            break;
          }
        }
      }
      if (!shouldRun) return;
      if (tick) clearTimeout(tick);
      tick = setTimeout(function () {
        initDesignGroupSwatches();
        runStorefrontApiDesignGroupCount();
      }, 50);
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  initDesignGroupSwatches();
  runStorefrontApiDesignGroupCount();
})();
